// extracted by mini-css-extract-plugin
module.exports = {"orderInfoView":"OrderInfoView_orderInfoView__lErpt","label":"OrderInfoView_label__M92qo","rowInfoDesktop":"OrderInfoView_rowInfoDesktop__FZ2Bg"};